import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiqSecuredResourcesService } from './miq-secured-resources.service';
import { MiqSecuredResourcesConfig, SECURED_RESOURCES_CONFIGS_TOKEN } from './miq-secured-resources.token';

@NgModule({
  imports: [CommonModule],
  providers: [MiqSecuredResourcesService],
})
export class MiqSecuredResourcesModule {
  static forRoot(configs: MiqSecuredResourcesConfig): ModuleWithProviders<MiqSecuredResourcesModule> {
    return {
      ngModule: MiqSecuredResourcesModule,
      providers: [{ provide: SECURED_RESOURCES_CONFIGS_TOKEN, useValue: configs }],
    };
  }
}
